module.exports = __webpack_public_path__ + "static/media/search.f726cd28.svg";